import React from "react";
import { config } from "config";
import { connect } from "react-redux";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import EditDefaultPlan from "./EditDefaultPlan";

function AddComputer2(props) {
  return (
    <div className="addcomputer_blk2" style={{}}>
      <h2 className="main_title">
        <Tooltip {...TOOLTIPS.backupSettings.back}>
          <button className="bck_btn" onClick={() => props.setPage(1)} />
        </Tooltip>{" "}
        Get Started
      </h2>
      <div className="welcome_item welcome_item_3">
        <div className="welcome_stpBlk">
          <div className="welcome_item_left">
            <h4>
              <span>1.</span> Download
            </h4>

            <p>
              {"The IDrive"}
              <sup>®</sup>
              {" Mirror " +
                (props.origin === "360" ? "thin client" : "") +
                " application is being downloaded on your computer. If your download has not started, "}
              <span
                style={{ color: "#29a5d8", cursor: "pointer" }}
                onClick={() =>
                  props.downloadClientSetupStart(
                    config.APP_INSTANCE === "ibackup" ? "ibackup" : null,
                    props.origin
                  )
                }
              >
                click here
              </span>
              .
            </p>
          </div>
          <div className="welcome_item_right">
            <div className="icon stp1">
              <svg
                x="0px"
                y="0px"
                viewBox="0 0 78.8 58.3"
                style={{ enableBackground: "new 0 0 78.8 58.3" }}
                xmlSpace="preserve"
              >
                <g>
                  <path
                    className="st0"
                    d="M64.7,25.2V9.5c0-2.4-2-4.4-4.4-4.4H10.2c-2.4,0-4.4,2-4.4,4.4V42c0,2.4,2,4.4,4.4,4.4h35.3"
                  />
                  <path
                    className="st1"
                    d="M44.7,41c0-0.4,0-0.8,0.1-1.3H7.6v2.1c0,1.5,1.2,2.8,2.8,2.8h34.7C44.8,43.4,44.7,42.2,44.7,41z"
                  />
                  <line className="st0" x1="7.6" y1={38} x2="45.1" y2="38.1" />
                  <line
                    className="st0"
                    x1="24.4"
                    y1="53.6"
                    x2="45.2"
                    y2="53.6"
                  />
                  <g>
                    <circle className="st0" cx="60.8" cy={41} r="13.3" />
                  </g>
                  <g>
                    <line
                      className="st0"
                      x1="60.8"
                      y1="35.1"
                      x2="60.8"
                      y2="47.3"
                    />
                    <polyline
                      className="st0"
                      points="55.2,42.2 60.8,47.8 66.3,42.2     "
                    />
                  </g>
                  <line
                    className="st0"
                    x1="31.8"
                    y1="48.1"
                    x2="31.8"
                    y2="53.6"
                  />
                  <line
                    className="st0"
                    x1="38.5"
                    y1="48.1"
                    x2="38.5"
                    y2="53.6"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div className="welcome_stpBlk">
          <div className="welcome_item_left">
            <h4>
              <span>2.</span> Install
            </h4>
            <p>Run the downloaded application on your computer.</p>
          </div>
          <div className="welcome_item_right">
            <div className="icon stp2">
              <svg
                x="0px"
                y="0px"
                viewBox="0 0 82.5 75.4"
                style={{ enableBackground: "new 0 0 82.5 75.4" }}
                xmlSpace="preserve"
              >
                <g>
                  <polyline
                    className="st0"
                    points="68.8,45.2 68.8,61 40.3,73 11.7,62 11.7,45.2   "
                  />
                  <path className="st1" d="M10.6,26.2" />
                  <line
                    className="st1"
                    x1="69.6"
                    y1="26.2"
                    x2="58.8"
                    y2="22.1"
                  />
                  <line
                    className="st1"
                    x1="21.4"
                    y1="22.1"
                    x2="10.6"
                    y2="26.2"
                  />
                  <line className="st0" x1="40.3" y1="37.2" x2="40.3" y2={73} />
                  <g>
                    <path
                      className="st2"
                      d="M54,21.5l-3.2-1.3c0.2-1.1,0.2-2.3,0-3.4l3.2-1.3c0.9-0.4,1.4-1.4,1-2.4l-0.5-1.2c-0.4-0.9-1.4-1.4-2.4-1
                                  L49,12.1c-0.6-0.9-1.4-1.7-2.4-2.4l1.3-3.2c0.4-0.9,0-2-1-2.4l-1.2-0.5c-0.9-0.4-2,0-2.4,1L42,7.8c-1.1-0.2-2.3-0.2-3.4,0
                                  l-1.3-3.2c-0.4-0.9-1.4-1.4-2.4-1l-1.2,0.5c-0.9,0.4-1.4,1.4-1,2.4L34,9.7c-0.9,0.6-1.7,1.4-2.4,2.4l-3.2-1.3c-0.9-0.4-2,0-2.4,1
                                  l-0.5,1.2c-0.4,0.9,0,2,1,2.4l3.2,1.3c-0.2,1.1-0.2,2.3,0,3.4l-3.2,1.3c-0.9,0.4-1.4,1.4-1,2.4l0.5,1.2c0.4,0.9,1.4,1.4,2.4,1
                                  l3.2-1.3c0.6,0.9,1.4,1.7,2.4,2.4l-1.3,3.2c-0.4,0.9,0,2,1,2.4l1.2,0.5c0.9,0.4,2,0,2.4-1l1.3-3.2c1.1,0.2,2.3,0.2,3.4,0l1.3,3.2
                                  c0.4,0.9,1.4,1.4,2.4,1l1.2-0.5c0.9-0.4,1.4-1.4,1-2.4l-1.3-3.2c0.9-0.6,1.7-1.4,2.4-2.4l3.2,1.3c0.9,0.4,2,0,2.4-1l0.5-1.2
                                  C55.4,22.9,55,21.8,54,21.5z"
                    />
                    <circle className="st2" cx="40.3" cy="18.4" r="5.2" />
                  </g>
                  <g>
                    <polygon
                      className="st0"
                      points="50.3,52.4 79.6,41.4 69.6,26.2 40.3,37.2    "
                    />
                    <polygon
                      className="st3"
                      points="51,50.3 76.4,40.4 69.1,28.4 43.8,37.9    "
                    />
                  </g>
                  <g>
                    <polygon
                      className="st0"
                      points="31.1,52.4 1.7,41.4 10.7,26.2 40.1,37.2     "
                    />
                    <polygon
                      className="st3"
                      points="11.3,28.3 36.7,38.2 30.4,50.2 5.1,40.7     "
                    />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div className="welcome_stpBlk">
          <div className="welcome_item_left">
            <h4>
              <span>3.</span> Secure
            </h4>
            <p>
              On successful installation you can manage computer backups from
              the web console.
            </p>
          </div>
          <div className="welcome_item_right">
            <div className="icon stp3">
              <svg
                x="0px"
                y="0px"
                viewBox="0 0 72.9 64.8"
                style={{ enableBackground: "new 0 0 72.9 64.8" }}
                xmlSpace="preserve"
              >
                <g>
                  <g>
                    <path
                      className="st0"
                      d="M46.5,52.7h16.4c2.4,0,4.4-2,4.4-4.4V10.1c0-2.4-2-4.4-4.4-4.4h-54c-2.4,0-4.4,2-4.4,4.4v38.2
                                  c0,2.4,2,4.4,4.4,4.4h17.7"
                    />
                    <path
                      className="st1"
                      d="M62.7,7.7H9.2c-1.5,0-2.8,1.2-2.8,2.8v2.4h59v-2.4C65.4,9,64.2,7.7,62.7,7.7z"
                    />
                    <line
                      className="st0"
                      x1="6.4"
                      y1="14.7"
                      x2="65.4"
                      y2="14.6"
                    />
                    <line
                      className="st0"
                      x1="60.8"
                      y1="10.7"
                      x2="63.5"
                      y2="10.7"
                    />
                    <line
                      className="st0"
                      x1="8.6"
                      y1="10.7"
                      x2="10.3"
                      y2="10.7"
                    />
                    <line
                      className="st0"
                      x1="11.6"
                      y1="10.7"
                      x2="13.3"
                      y2="10.7"
                    />
                    <line
                      className="st0"
                      x1="14.5"
                      y1="10.7"
                      x2="16.3"
                      y2="10.7"
                    />
                    <line
                      className="st0"
                      x1="53.1"
                      y1="10.7"
                      x2="59.1"
                      y2="10.7"
                    />
                  </g>
                  <path
                    className="st0"
                    d="M53.7,28.3l-17.2-6l-17.2,6c0,0-0.6,24,17.2,32.8C54.3,52.3,53.7,28.3,53.7,28.3z"
                  />
                  <polyline
                    className="st0"
                    points="31.1,40.8 35.3,45 43.8,36.5   "
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
        <EditDefaultPlan />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    origin: state.account.origin
  };
}

export default connect(mapStateToProps)(AddComputer2);
